export const GEM_SOCKET_UPDATE_LOG_LIST_REQUEST = 'GEM_SOCKET_UPDATE_LOG_LIST_REQUEST';
